import { defineComponent as _defineComponent } from 'vue'
import Editor from '@/ui/components/richText/Editor.vue';
  import { onBeforeUnmount, computed } from 'vue';
  import { debounce } from 'lodash';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RichTextResponse',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ['update-response'],
  setup(__props, { emit }) {

const { item } = __props;

  

  

  const isRteResponse = computed(() => {
    return !!item.rte_response;
  });

  const currentText = computed(() => {
    return (isRteResponse.value ? item.html_response : item.response) ?? '';
  });

  const isReadOnly = computed(() => item?.prefillReadOnly === true);

  const debounceUpdate = debounce(value => emit('update-response', item.uuid, value), 10);

  onBeforeUnmount(() => {
    debounceUpdate.cancel();
  });

return { __sfc: true,emit, isRteResponse, currentText, isReadOnly, debounceUpdate, Editor }
}

})